import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function BackgroundInfoForm({
  graduationTypeName,
  graduationType,
  handleChange,
  values
 }) {
  const universityName = graduationTypeName + " Üniversitesi";
  const departmentName = graduationTypeName + " Bölümü";
  const yearName = graduationTypeName + " Mezuniyet Yılı";
  const universityId = graduationType + ".university";
  const departmentId = graduationType + ".department";
  const yearId = graduationType + ".graduationYear";
  const graduationYear = values.graduationYear != null ? values.graduationYear : "";

  return (
    <>
      <Form.Group as={Row} controlId={universityId}>
        <Form.Label column sm={3}>
          {universityName}
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.university} placeholder={universityName} onChange={handleChange} />
        </Col>
      </Form.Group>
                      
      <Form.Group as={Row} controlId={departmentId}>
        <Form.Label column sm={3}>
          {departmentName}
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.department} placeholder={departmentName} onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={yearId}>
        <Form.Label column sm={3}>
          {yearName}
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="number" min={0} value={graduationYear} placeholder={yearName} onChange={handleChange} />
        </Col>
      </Form.Group>
    </>        
  );
}